'use strict';

import {isDesktopMode} from "../language/langSwitcher";

export class Slide {
    #element = document.createElement('div');;
    #args = null;
    #imgPath = null;
    #titleText = null;

    constructor(imgPath, text, parent = null, args) {
        this.#element.classList.add('slide');
        this.#args = args;
        this.#imgPath = imgPath;
        this.#titleText = text;

        this.#createContentElements();

        parent.appendChild(this.#element);
    }

    get get() {
        return this.#element;
    }

    #createContentElements() {
        this.#element.appendChild(this.#image);
        this.#element.appendChild(this.#title);
    }

    get #image() {
        const element = document.createElement('div');
        element.classList.add('img');
        element.style.animation = this.#args.imageAnimation;
        element.style.zIndex = this.#args.zIndex;
        element.style.backgroundImage = `url("${this.#imgPath}")`;

        return element;
    }

    get #title() {
        const element = document.createElement('div');
        element.classList.add('title');
        element.style.animation = this.#args.titleAnimation;
        element.innerHTML = `${this.#getFormattedText()}`;

        return element;
    }

    #getFormattedText() {
        let symbolsInRow = 35;

        if(isDesktopMode()) {
            symbolsInRow = 50;
        }

        const splitText = this.#titleText.split(" ");
        let formattedText = '';
        let line = '';

        for (let i = 0; i < splitText.length; i++) {
            const nextConcat = line + splitText[i] + ' ';
            if (nextConcat.length <= symbolsInRow) {
                line = nextConcat;
            } else {
                formattedText += line + '<br>';
                line = '' + splitText[i] + ' ';
            }
        }
        formattedText += line;

        return formattedText;
    }
}

